import { Component } from "react";

// markup
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Button from "@material-ui/core/Button";

export default class TableCellReviewCreditApplicationActions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
    };
  }

  handleOpen = () => {
    this.props.getAccountInfoForId(this.props.item.BorrowerId);
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  removeFromOnHold = () => {
    this.props.removeFromOnHold(this.props.item.Id);
  };

  render() {
    let noActionText = "No action Available";
    let isEmptyGuid =
      this.props.item.BankAccountId === "00000000-0000-0000-0000-000000000000";

    if (isEmptyGuid) noActionText = "User did not select direct debit account";

    let isApproveDisabled = isEmptyGuid; //&& import.meta.env.MODE != 'development';
    const actions = [
      <Button
        key="2"
        variant="outlined"
        keyboardFocused={false}
        onClick={this.removeFromOnHold}
      >
        Remove from on hold
      </Button>,
      <Button
        key="3"
        variant="outlined"
        keyboardFocused={false}
        onClick={this.handleClose}
      >
        Cancel
      </Button>,
    ];

    return (
      <div className="table-cell-actions">
        <Button variant="contained" color="primary" onClick={this.handleOpen}>
          Remove From On Hold
        </Button>
        <Dialog
          title="Approve/Reject application"
          modal={false}
          open={this.state.open}
          onClose={this.handleClose}
        >
          <DialogContent>
            {isApproveDisabled ? <h3>{noActionText}</h3> : undefined} <br />
            Mark as not on hold:{this.props.item.Id}
          </DialogContent>
          <DialogActions>{actions}</DialogActions>
        </Dialog>
      </div>
    );
  }
}
